<!--
  @description 业务拨测组件
  @author xiehan
  @date 2018/12/04
-->

<template>
  <div class="dial-request">
    <el-form label-width="90px" 
      input-width="auto" 
      style="width: 660px;" 
      v-for="(item, reqIndex) in requestList"
      :key="'request' + reqIndex">
      <el-form-item :label="$t('dial.step') + (reqIndex + 1)">
        <el-button type="primary" 
          @click="item.visible = !item.visible"
          v-text="item.visible ? $t('dial.hide') : $t('dial.show')">
        </el-button>
        <el-button type="danger" 
          @click="removeRequest(reqIndex)"
          v-text="$t('common.delete')">
        </el-button>
      </el-form-item>
      <el-collapse-transition>
        <div v-show="item.visible">
          <el-form-item>
            <el-input :placeholder="$t('dial.url')" class="input-with-select" v-model="item.url">
              <el-select v-model="item.requestType" slot="prepend" @change="selectChange(reqIndex, item.requestType)">
                <el-option label="GET" value="GET"></el-option>
                <el-option label="POST" value="POST"></el-option>
                <el-option label="PUT" value="PUT"></el-option>
                <el-option label="PATCH" value="PATCH"></el-option>
                <el-option label="DELETE" value="DELETE"></el-option>
              </el-select>
              <el-button slot="append" 
                @click="testSingleDial(reqIndex)"
                type="primary" 
                v-text="$t('dial.test')"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-tabs style="height: 214px;" type="border-card" v-model="item.activeName">
              <el-tab-pane label="Headers" name="header">
                <el-input
                  type="textarea"
                  :rows="6"
                  resize="none"
                  v-model="item.header">
                </el-input>
              </el-tab-pane>
              <el-tab-pane label="Params" name="param">
                <el-row :gutter="10">
                  <el-col :span="9">
                    <el-form-item label="KEY" label-width="auto">
                    </el-form-item>
                  </el-col>
                  <el-col :span="9">
                    <el-form-item label="VALUE" label-width="auto">
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                  </el-col>
                </el-row>
                <el-row :gutter="10" v-for="(p_item, p_index) in item.paramList" :key="'params' + p_index">
                  <el-col :span="9">
                    <el-input v-model="p_item.key"></el-input>
                  </el-col>
                  <el-col :span="9">
                    <el-input v-model="p_item.value"></el-input>
                  </el-col>
                  <el-col :span="6">
                    <el-button icon="icon-xinzeng" @click="addParamsList(reqIndex)"></el-button>
                    <el-button icon="icon-shanchu1" @click="removeParamsList(reqIndex, p_index)"></el-button>
                  </el-col>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="Cookies" name="cookie">
                <el-input
                  type="textarea"
                  :rows="6"
                  resize="none"
                  v-model="item.cookie">
                </el-input>
              </el-tab-pane>
              <el-tab-pane label="Body" :disabled="!item.bodyDisable" name="body">
                <el-radio-group v-model="item.bodyRadio" :disabled="!item.bodyDisable">
                  <el-radio label="form-data">form-data</el-radio>
                  <el-radio label="raw">raw</el-radio>
                  <el-radio label="x-www-form-urlencoded">x-www-form-urlencoded</el-radio>
                </el-radio-group>
                <el-input
                  type="textarea"
                  :rows="4"
                  :disabled="!item.bodyDisable"
                  resize="none"
                  v-model="item.body">
                </el-input>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item>
            <label class="el-form-item__label">Response</label>
            <el-input
              type="textarea"
              :rows="3"
              :readonly="true"
              :disabled="true"
              v-model="item.response">
            </el-input>
          </el-form-item>
        </div>
      </el-collapse-transition>
    </el-form>
    <el-button icon="icon-xinzeng" 
      class="dial-request-btn"
      type="primary" 
      @click="addRequest"></el-button>
  </div>
</template>

<script>
  import { extend } from '@/utils/tool'

  const DEFAULT_REQUEST = {
    url: '',
    paramList: [{
      key: '',
      value: ''
    }],
    requestType: 'GET',
    header: '',
    body: '',
    cookie: '',
    visible: true,
    bodyDisable: false,
    bodyRadio: 'form-data',
    activeName: 'header',
    response: ''
  }

  export default {
    data () {
      return {
        requestList: [extend(true, {}, DEFAULT_REQUEST)]
      }
    },
    methods: {
      addParamsList (i) {
        this.requestList[i].paramList.push({ key: '', value: '' })
      },
      removeParamsList (reqIndex, prarmIndex) {
        if (this.requestList[reqIndex].paramList.length > 1) {
          this.requestList[reqIndex].paramList.splice(prarmIndex, 1)
        }
      },
      selectChange (i, val) {
        this.$nextTick(() => {
          const visibleList = ['POST', 'PUT', 'PATCH']
          this.requestList[i].bodyDisable = !!(visibleList.find(item => item === val))
          if (this.requestList[i].activeName === 'body' && !this.requestList[i].bodyDisable) {
            this.requestList[i].activeName = 'header'
          }
        })
      },
      addRequest () {
        this.requestList.push(extend(true, {}, DEFAULT_REQUEST))
      },
      removeRequest (i) {
        if (this.requestList.length > 1) this.requestList.splice(i, 1)
      },
      getRequestList () {
        let requestList = []
        for (let i = 0; i < this.requestList.length; i++) {
          if (!this.translateRequest(this.requestList[i])) {
            return false
          }
          requestList.push(this.translateRequest(this.requestList[i]))
        }
        return requestList
      },
      setRequestList (requestList) {
        let requests = []
        requestList.map(item => {
          // 转换param
          let paramList = []
          if (Object.keys(item.param).length > 0) {
            for (let i in item.param) {
              paramList.push({
                key: i,
                value: item.param[i]
              })
            }
          }
          // 转换body
          let bodyRadio = 'form-data'
          if (Object.keys(item.body).length > 0) {
            bodyRadio = Object.keys(item.body)[0]
          }
          let obj = {
            url: item.url,
            paramList: paramList.length > 0 ? paramList : [{ key: '', value: '' }],
            requestType: item.requestType,
            header: Object.keys(item.header).length === 0 ? '' : JSON.stringify(item.header),
            body: Object.keys(item.body).length === 0 ? '' : JSON.stringify(item.body[bodyRadio]),
            cookie: Object.keys(item.cookie).length === 0 ? '' : JSON.stringify(item.cookie),
            bodyRadio: bodyRadio,
            visible: true,
            bodyDisable: item.requestType !== 'GET' && item.requestType !== 'DELETE',
            activeName: 'header',
            response: ''
          }
          requests.push(obj)
        })
        this.requestList = requests
      },
      resetRequestList () {
        this.requestList = [extend(true, {}, DEFAULT_REQUEST)]
      },
      testSingleDial (i) {
        this.$emit('testSingleDial', {
          requestInfo: this.translateRequest(this.requestList[i]),
          requestIndex: i
        })
      },
      setResponse (i, message) {
        this.requestList[i].response = message
      },
      checkObject (obj, item) {
        try {
          if (typeof JSON.parse(obj[item]) !== 'object') {
            this.warningMessage(item)
            return false
          }
        } catch (err) {
          this.warningMessage(item)
          return false
        }
        return true
      },
      warningMessage (str) {
        this.$message({
          message: `${str}${this.$t('dial.objectTips')}`,
          type: 'warning'
        })
      },
      // 把数据转换成接口需要的数据格式
      translateRequest (obj) {
        let newObj = extend(true, {}, obj)
        let checkList = ['header', 'cookie']

        if (newObj.bodyDisable) checkList.push('body')

        for (let i = 0; i < checkList.length; i++) {
          if (newObj[checkList[i]] && !this.checkObject(newObj, checkList[i])) {
            return false
          } else {
            newObj[checkList[i]] = newObj[checkList[i]] ? JSON.parse(newObj[checkList[i]]) : JSON.parse('{}')
          }
        }

        let paramObj = {}
        newObj.paramList.map(item => {
          if (item.key) paramObj[item.key] = item.value
        })

        let bodyObj = {}
        if (newObj.bodyDisable) {
          bodyObj[newObj.bodyRadio] = newObj.body
        }
  
        return {
          body: bodyObj,
          cookie: newObj.cookie,
          header: newObj.header,
          param: paramObj,
          requestType: obj.requestType,
          url: obj.url
        }
      }
    }
  }
</script>

<style>
  .input-with-select .el-select .el-input {
    width: 100px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  .input-with-select .el-input-group__append .el-button {
    color: #fff;
    background-color: #0B8DE5;
    border-color: #0B8DE5;
  }
  .input-with-select .el-input-group__append .el-button:hover {
    background: #3ca4ea;
    border-color: #3ca4ea;
    color: #fff;
  }
  .dial-request .el-tabs__content {
    height: 144px;
    overflow-y: scroll;
  }
  .dial-request-btn {
    width: 62px;
    margin-left: 90px;
  }
</style>